var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsightsColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_193_215)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3748 12.3333C30.1394 12.3333 28.8907 14.5533 29.3994 16.2029L23.9265 21.6913C23.464 21.5525 22.7857 21.5525 22.3232 21.6913L18.3919 17.76C18.9161 16.1104 17.6673 13.875 15.4165 13.875C13.1811 13.875 11.9169 16.095 12.4411 17.76L5.41109 24.7746C3.7615 24.2658 1.5415 25.5146 1.5415 27.75C1.5415 29.4458 2.929 30.8333 4.62484 30.8333C6.86025 30.8333 8.109 28.6133 7.60025 26.9638L14.6148 19.9338C15.0773 20.0725 15.7557 20.0725 16.2182 19.9338L20.1494 23.865C19.6253 25.5146 20.874 27.75 23.1248 27.75C25.3603 27.75 26.6244 25.53 26.1003 23.865L31.5886 18.3921C33.2382 18.9008 35.4582 17.6521 35.4582 15.4167C35.4582 13.7208 34.0707 12.3333 32.3748 12.3333Z",
    fill: "url(#paint1_linear_193_215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.125 13.875L24.5742 10.6837L27.75 9.25L24.5742 7.81625L23.125 4.625L21.7067 7.81625L18.5 9.25L21.7067 10.6837L23.125 13.875Z",
    fill: "url(#paint2_linear_193_215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39567 16.9583L6.16651 13.875L9.24984 13.1042L6.16651 12.3333L5.39567 9.25L4.62484 12.3333L1.5415 13.1042L4.62484 13.875L5.39567 16.9583Z",
    fill: "url(#paint3_linear_193_215)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_215",
    x1: 18.5,
    y1: 0,
    x2: 18.5,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_193_215",
    x1: 18.4998,
    y1: 12.3333,
    x2: 18.4998,
    y2: 30.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7601D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_193_215",
    x1: 23.125,
    y1: 4.625,
    x2: 23.125,
    y2: 13.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7601D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_193_215",
    x1: 5.39567,
    y1: 9.25,
    x2: 5.39567,
    y2: 16.9583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7601D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_193_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsColored);
export default __webpack_public_path__ + "static/media/insights_colored.7ff803a74dc9dc5a00059ec554a586ae.svg";
export { ForwardRef as ReactComponent };